module.exports = __webpack_public_path__ + "assets/622161943bc8384373189490ff2f036a.png";